<div class="cardLayout">
  <div class="formLabelSemiBoldfs16 mb-5">Employee Replacement</div>
  <div class="close_bg display-content-end" (click)="closeDialog()">
    <img class="cp" src="././assets/icon/close_icon.png">
  </div>
  <ion-row>
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0">
      <ion-accordion-group [multiple]="true">
        <ion-accordion value="first" class="mb-10"
          [ngClass]="employeementRelatedUserForm.valid == false && addSubmitForm ? 'errorBorder':''">
          <ion-item slot="header">
            <label class="font_semibold fs-14 fs_12ForMobile">Current Employment Related Information</label>
          </ion-item>
          <div class="p-10" slot="content">
            <form [formGroup]="employeementRelatedUserForm">
              <ion-row>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Employee Code<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="empCode">
                    <mat-error *ngIf="employeementRelatedUserForm.controls['empCode'].hasError('required')">Employee
                      Code is required</mat-error>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Employment Category<span class="red-cl">&nbsp;*</span>
                  </div>
                  <ng-select placeholder="Select Employment Category" formControlName="employmentCategory">
                    <ng-option value="Staff">Staff</ng-option>
                    <ng-option value="Worker">Worker</ng-option>
                    <ng-option value="Contractual">Contractual</ng-option>
                    <ng-option value="Trainee">Trainee</ng-option>
                  </ng-select>
                  <label class="fs-12 red-cl font_regular"
                    *ngIf="addSubmitForm && employeementRelatedUserForm.controls['employmentCategory'].hasError('required')">Employment
                    Category is required</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Employment Type<span class="red-cl">&nbsp;*</span></div>
                  <ng-select placeholder="Select Employment Type" formControlName="employmentType">
                    <ng-option value="Probation">Probation</ng-option>
                    <ng-option value="Confirmed">Confirmed</ng-option>
                  </ng-select>
                  <label class="fs-12 red-cl font_regular"
                    *ngIf="addSubmitForm && employeementRelatedUserForm.controls['employmentType'].hasError('required')">Employment
                    Type is required</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Retirement Age</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular"
                      formControlName="retirementAge" (input)="checkNumerIsPositiveemployeementRelatedUserForm($event,'retirementAge')">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Employee Status<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Employee Status" formControlName="empStatus">
                      <mat-option [value]="'Active'">Active</mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="employeementRelatedUserForm.controls['empStatus'].hasError('required')">Employee Status
                      is
                      required</mat-error>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Date Of Joining<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input readonly matInput [matDatepicker]="dateOfJoining" formControlName="dateOfJoining"
                      placeholder="DD/MM/YYYY">
                    <mat-datepicker-toggle matIconSuffix [for]="dateOfJoining"></mat-datepicker-toggle>
                    <mat-datepicker #dateOfJoining></mat-datepicker>
                    <mat-error
                      *ngIf="employeementRelatedUserForm.controls['dateOfJoining'].hasError('required')">Date Of
                      Joining is required</mat-error>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10"
                  *ngIf="employeementRelatedUserForm.value.empStatus == 'Exited'">
                  <div class="formLabelRegularfs14 mb-5">Date Of Resignation<span class="red-cl">&nbsp;*</span>
                  </div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input readonly matInput [matDatepicker]="dateOfResignation" formControlName="dateOfResignation"
                      placeholder="DD/MM/YYYY" [min]="employeementRelatedUserForm.value.dateOfJoining">
                    <mat-datepicker-toggle matIconSuffix [for]="dateOfResignation"></mat-datepicker-toggle>
                    <mat-datepicker #dateOfResignation></mat-datepicker>
                    <mat-error
                      *ngIf="employeementRelatedUserForm.controls['dateOfResignation'].hasError('required')">Date Of
                      Resignation is required</mat-error>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10"
                  *ngIf="employeementRelatedUserForm.value.empStatus == 'Exited'">
                  <div class="formLabelRegularfs14 mb-5">LWD<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input readonly matInput [matDatepicker]="lwd" formControlName="lastWorkingDate"
                      placeholder="DD/MM/YYYY" [min]="employeementRelatedUserForm.value.dateOfResignation">
                    <mat-datepicker-toggle matIconSuffix [for]="lwd"></mat-datepicker-toggle>
                    <mat-datepicker #lwd></mat-datepicker>
                    <mat-error
                      *ngIf="employeementRelatedUserForm.controls['lastWorkingDate'].hasError('required')">LWD is required</mat-error>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Group Name<span class="red-cl">&nbsp;*</span></div>
                  <ng-select [addTag]="true" placeholder="Select Group Name" formControlName="groupName">
                    <ng-option [value]="item.id" *ngFor="let item of getListOfGroupNameOfComp">{{item.name}}</ng-option>
                  </ng-select>
                  <label class="fs-12 red-cl font_regular"
                    *ngIf="addSubmitForm && employeementRelatedUserForm.controls['groupName'].hasError('required')">Group
                    Name is required</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Company Name<span class="red-cl">&nbsp;*</span></div>
                  <ng-select [addTag]="true" placeholder="Select Company Name" formControlName="companyName">
                    <ng-option [value]="item.id" *ngFor="let item of getListOfCompanyNameOfComp">{{item.name}}</ng-option>
                  </ng-select>
                  <label class="fs-12 red-cl font_regular"
                    *ngIf="addSubmitForm && employeementRelatedUserForm.controls['companyName'].hasError('required')">Company
                    Name is required</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Official Email<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type here" class="font_regular" formControlName="officialEmail" (blur)="checkEmailInTheSystem()">
                    <mat-error
                      *ngIf="employeementRelatedUserForm.controls['officialEmail'].hasError('required')">Official Email is required</mat-error>
                    <mat-error
                      *ngIf="employeementRelatedUserForm.controls['officialEmail'].hasError('pattern')">Enter Valid Official Email</mat-error>
                  </mat-form-field>
                  <div class="fs-12 red-cl mt-15 font_regular"*ngIf="showErrorMsgOfExistEmail">Official Email Already Exists</div>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Reporting Manager Name<span class="red-cl">&nbsp;*</span></div>
                  <ng-select [clearable]="false" placeholder="Select Manager Name" formControlName="reportingManagerName"
                  (change)="onSelectionOfManager()">
                    <ng-option [value]="item.id"
                      *ngFor="let item of assignReporteesDropdown">{{item.name}}</ng-option>
                  </ng-select>
                  <label class="fs-12 red-cl font_regular"
                    *ngIf="addSubmitForm && employeementRelatedUserForm.controls['reportingManagerName'].hasError('required')">Reporting Manager Name
                      is required</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Reporting Manager Code<span class="red-cl">&nbsp;*</span>
                  </div>
                  <div class="inputBox notAllowed">{{employeementRelatedUserForm.value.reportingManagerCode}}</div>
                  <label class="fs-12 red-cl font_regular"
                  *ngIf="addSubmitForm && employeementRelatedUserForm.controls['reportingManagerName'].hasError('required')">Reporting Manager Code
                    is required</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Dotted Reporting Manager Name
                  </div>
                  <ng-select placeholder="Select Dotted Reporting Manager Name" formControlName="dottedReportingManagerName"
                  (change)="onSelectionOfDottedManager()">
                    <ng-option [value]="item.id"
                      *ngFor="let item of assignReporteesDropdown">{{item.name}}</ng-option>
                  </ng-select>
                  <!-- <label class="fs-12 red-cl font_regular"
                  *ngIf="addSubmitForm && employeementRelatedUserForm.controls['dottedReportingManagerName'].hasError('required')">Dotted Reporting Manager Code
                    is required</label> -->
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Dotted Reporting Manager Code</div>
                  <div class="inputBox notAllowed">{{employeementRelatedUserForm.value.dottedReportingManagerCode}}</div>
                  <!-- <label class="fs-12 red-cl font_regular"
                  *ngIf="addSubmitForm && employeementRelatedUserForm.controls['dottedReportingManagerCode'].hasError('required')">Dotted Reporting Manager Code
                    is required</label> -->
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">HOD Name<span class="red-cl">&nbsp;*</span></div>
                  <ng-select [clearable]="false"placeholder="Select HOD Name" formControlName="hodName"
                  (change)="onSelectionOfHod()">
                    <ng-option [value]="item.id"
                      *ngFor="let item of assignReporteesDropdown">{{item.name}}</ng-option>
                  </ng-select>
                  <label class="fs-12 red-cl font_regular"
                  *ngIf="addSubmitForm && employeementRelatedUserForm.controls['hodName'].hasError('required')">HOD Name
                    is required</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">HOD Code<span class="red-cl">&nbsp;*</span></div>
                  <div class="inputBox notAllowed">{{employeementRelatedUserForm.value.hodCode}}</div>
                  <label class="fs-12 red-cl font_regular"
                  *ngIf="addSubmitForm && employeementRelatedUserForm.controls['hodCode'].hasError('required')">HOD Code
                    is required</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Band<span class="red-cl">&nbsp;*</span></div>
                  <ng-select [addTag]="true" placeholder="Select Band" formControlName="band">
                    <ng-option [value]="item.id" *ngFor="let item of getListOfBandNameOfComp">{{item.name}}</ng-option>
                  </ng-select>
                  <label class="fs-12 red-cl font_regular"
                  *ngIf="addSubmitForm && employeementRelatedUserForm.controls['band'].hasError('required')">Band
                    is required</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Grade<span class="red-cl">&nbsp;*</span></div>
                  <ng-select [addTag]="true" placeholder="Select Grade" formControlName="grade">
                    <ng-option [value]="item.id" *ngFor="let item of getListOfGradeNameOfComp">{{item.name}}</ng-option>
                  </ng-select>
                  <label class="fs-12 red-cl font_regular"
                  *ngIf="addSubmitForm && employeementRelatedUserForm.controls['grade'].hasError('required')">Grade
                    is required</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Designation<span class="red-cl">&nbsp;*</span></div>
                  <ng-select [addTag]="true" placeholder="Select Designation" formControlName="designation">
                    <ng-option [value]="item.id" *ngFor="let item of getListOfDesignationsOfComp">{{item.name}}</ng-option>
                  </ng-select>
                  <label class="fs-12 red-cl font_regular"
                  *ngIf="addSubmitForm && employeementRelatedUserForm.controls['designation'].hasError('required')">Designation
                    is required</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Department/Function<span class="red-cl">&nbsp;*</span>
                  </div>
                  <ng-select [addTag]="true" placeholder="Select Department/Function" formControlName="department">
                    <ng-option [value]="item.id" *ngFor="let item of getListOfDepartmentsOfComp">{{item.name}}</ng-option>
                  </ng-select>
                  <label class="fs-12 red-cl font_regular"
                  *ngIf="addSubmitForm && employeementRelatedUserForm.controls['department'].hasError('required')">Department/Function
                    is required</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Sub Department/Sub Function</div>
                  <ng-select [addTag]="true" placeholder="Select Sub Department/Sub Function" formControlName="subDepartment">
                    <ng-option [value]="item.id" *ngFor="let item of getListOfSubDepartmentsOfComp">{{item.name}}</ng-option>
                  </ng-select>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Work Location-State<span class="red-cl">&nbsp;*</span></div>
                  <ng-select dropdownPosition="top" placeholder="Select Work Location-State" formControlName="workLocationState">
                    <ng-option [value]="item" *ngFor="let item of states">{{item}}</ng-option>
                  </ng-select>
                  <label class="fs-12 red-cl font_regular"
                        *ngIf="addSubmitForm && employeementRelatedUserForm.controls['workLocationState'].hasError('required')">Work Location-State
                        is required</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Work Location- City/ Town<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="workLocationCity">
                    <mat-error
                    *ngIf="employeementRelatedUserForm.controls['workLocationCity'].hasError('required')">Work Location- City/ Town is required</mat-error>
                  </mat-form-field>
                </ion-col>
                <!-- <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Catalyst Role</div>
                  <ng-select placeholder="Select Catalyst Role" formControlName="catalystRole">
                    <ng-option value="HR Admin">HR Admin</ng-option>
                    <ng-option value="Admin">Admin</ng-option>
                  </ng-select>
                </ion-col> -->
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Designation at DOJ<span class="red-cl">&nbsp;*</span></div>
                  <ng-select dropdownPosition="top" [addTag]="true" placeholder="Select Designation  at DOJ" formControlName="designationAtDoj">
                    <ng-option [value]="item.id" *ngFor="let item of getListOfDesignationsAtDOJOfComp">{{item.name}}</ng-option>
                  </ng-select>
                  <label class="fs-12 red-cl font_regular"
                        *ngIf="addSubmitForm && employeementRelatedUserForm.controls['designationAtDoj'].hasError('required')">Designation at DOJ
                        is required</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">No. of Promotions/ Upgrades</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input type="number" matInput placeholder="Type number here" class="font_regular" formControlName="noOfPromotions"
                    (input)="checkNumerIsPositiveemployeementRelatedUserForm($event,'noOfPromotions')">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Current Individual Performance Score</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" 
                    formControlName="currentPerformanceScore" (input)="checkNumerIsPositiveemployeementRelatedUserForm($event,'currentPerformanceScore')">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Current Individual Performance Rating</div>
                  <ng-select dropdownPosition="top" [addTag]="true" placeholder="Select" formControlName="currentPerformanceRating">
                    <ng-option [value]="item.id" *ngFor="let item of getListOfCurrentRatingOfComp">{{item.name}}</ng-option>
                  </ng-select>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Last Year Individual Performance Score</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" 
                    formControlName="lastYearPerformanceScore" (input)="checkNumerIsPositiveemployeementRelatedUserForm($event,'lastYearPerformanceScore')">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Last Year Individual Performance Rating</div>
                  <ng-select dropdownPosition="top" [addTag]="true" placeholder="Select" formControlName="lastYearPerformanceRating">
                    <ng-option [value]="item.id" *ngFor="let item of getListOfLastYearRatingOfComp">{{item.name}}</ng-option>
                  </ng-select>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Year Before Last Year Individual Performance Score</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" 
                    formControlName="yearBeforeLastYearPerformanceScore" (input)="checkNumerIsPositiveemployeementRelatedUserForm($event,'yearBeforeLastYearPerformanceScore')">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Year Before Last Year Individual Performance Rating</div>
                  <ng-select dropdownPosition="top" [addTag]="true" placeholder="Select" formControlName="yearBeforeLastYearPerformanceRating">
                    <ng-option [value]="item.id" *ngFor="let item of getListOfLastToLastYearRatingOfComp">{{item.name}}</ng-option>
                  </ng-select>
                </ion-col>
              </ion-row>
            </form>
          </div>
        </ion-accordion>
        <ion-accordion value="second" class="mb-10"
          [ngClass]="generalInformationUserForm.valid == false && addSubmitForm ? 'errorBorder':''">
          <ion-item slot="header">
            <label class="font_semibold fs-14 fs_12ForMobile">General Information</label>
          </ion-item>
          <div class="p-10" slot="content">
            <form [formGroup]="generalInformationUserForm">
              <ion-row>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Salutation<span class="red-cl">&nbsp;*</span></div>
                  <ng-select dropdownPosition="bottom" placeholder="Select Salutation" formControlName="salutation">
                    <ng-option value="Mr.">Mr.</ng-option>
                    <ng-option value="Mrs.">Mrs.</ng-option>
                    <ng-option value="Ms.">Ms.</ng-option>
                    <ng-option value="Dr.">Dr.</ng-option>
                  </ng-select>
                  <label class="fs-12 red-cl font_regular"
                    *ngIf="addSubmitForm && generalInformationUserForm.controls['salutation'].hasError('required')">Salutation
                      is required</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">First Name<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="firstName">
                    <mat-error *ngIf="generalInformationUserForm.controls['firstName'].hasError('required')">First Name
                      is required</mat-error>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Last Name<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="lastName">
                    <mat-error *ngIf="generalInformationUserForm.controls['lastName'].hasError('required')">First Name
                      is required</mat-error>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Gender<span class="red-cl">&nbsp;*</span></div>
                  <ng-select dropdownPosition="bottom" placeholder="Select Gender" formControlName="gender">
                    <ng-option value="Male">Male</ng-option>
                    <ng-option value="Female">Female</ng-option>
                    <ng-option value="Cannot_Disclose">Don't wish to disclose</ng-option>
                  </ng-select>
                  <label class="fs-12 red-cl font_regular"
                  *ngIf="addSubmitForm && generalInformationUserForm.controls['gender'].hasError('required')">Gender
                    is required</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Country<span class="red-cl">&nbsp;*</span></div>
                  <ng-select dropdownPosition="bottom" placeholder="Select Country" formControlName="country">
                    <ng-option [value]="item.id" *ngFor="let item of getCountryList">{{item.name}}</ng-option>
                  </ng-select>
                  <label class="fs-12 red-cl font_regular"
                  *ngIf="addSubmitForm && generalInformationUserForm.controls['country'].hasError('required')">Gender
                    is required</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Present Address<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-input-style">
                    <textarea matInput placeholder="Type text here" formControlName="address"></textarea>
                    <mat-error *ngIf="generalInformationUserForm.controls['address'].hasError('required')">Present Address
                      is required</mat-error>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Permanent Address</div>
                  <mat-form-field class="w-100 mat-input-style">
                    <textarea matInput placeholder="Type text here" formControlName="permanentAddress"></textarea>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Marital Status</div>
                  <ng-select dropdownPosition="bottom" placeholder="Select Marital Status" formControlName="maritalStatus">
                    <ng-option value="Married">Married</ng-option>
                    <ng-option value="Single">Single</ng-option>
                  </ng-select>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10" 
                *ngIf="generalInformationUserForm.value.maritalStatus == 'Married'">
                  <div class="formLabelRegularfs14 mb-5">Date of Marriage</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input readonly matInput [matDatepicker]="dateOfMarriage" [max]="currentDate" formControlName="dateOfMarriage" placeholder="DD/MM/YYYY">
                    <mat-datepicker-toggle matIconSuffix [for]="dateOfMarriage"></mat-datepicker-toggle>
                    <mat-datepicker #dateOfMarriage></mat-datepicker>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Date of Birth<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input readonly matInput [matDatepicker]="dateOfBirth" [max]="currentDate" formControlName="dateOfBirth" placeholder="DD/MM/YYYY" (dateChange)="calculateAgeFromDOB()">
                    <mat-datepicker-toggle matIconSuffix [for]="dateOfBirth"></mat-datepicker-toggle>
                    <mat-datepicker #dateOfBirth></mat-datepicker>
                    <mat-error *ngIf="generalInformationUserForm.controls['dateOfBirth'].hasError('required')">Date of Birth
                      is required</mat-error>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Age</div>
                  <div class="inputBox notAllowed">{{generalInformationUserForm.value.age}}</div>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Personal Email</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="personalEmail">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">AdharCard No.<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input type="number" matInput placeholder="Type number here" class="font_regular" formControlName="aadharNo" 
                    (input)="checkNumerIsPositivgeneralInformationUserForm($event,'aadharNo');checkAadharNo()">
                    <mat-error *ngIf="generalInformationUserForm.controls['aadharNo'].hasError('required')">AdharCard No.
                      is required</mat-error>
                    <mat-error *ngIf="generalInformationUserForm.controls['aadharNo'].hasError('pattern')">Enter Valid AdharCard No.
                      </mat-error>
                  </mat-form-field>
                  <label class="fs-12 red-cl font_regular" *ngIf="showErrorMsgOfExistAddharNo">AdharCard No. Already Exists</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">PAN No.<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="panNo" (input)="checkPanNo()">
                    <mat-error *ngIf="generalInformationUserForm.controls['panNo'].hasError('required')">PAN No.
                      is required</mat-error>
                    <mat-error *ngIf="generalInformationUserForm.controls['panNo'].hasError('pattern')">Enter Valid PAN No.
                      </mat-error>
                  </mat-form-field>
                  <label class="fs-12 red-cl font_regular" *ngIf="showErrorMsgOfExistPAN">PAN No. Already Exists</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">UAN No.</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="uan" 
                    (input)="checkNumerIsPositivgeneralInformationUserForm($event,'uan');checkUanNo()">
                    <mat-error *ngIf="generalInformationUserForm.controls['uan'].hasError('pattern')">Enter Valid UAN No.
                    </mat-error>
                  </mat-form-field>
                  <label class="fs-12 red-cl font_regular" *ngIf="showErrorMsgOfExistUAN">UAN No. Already Exists</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Mobile No (Whats app No.)<span class="red-cl">&nbsp;*</span>
                  </div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="contactNo" 
                    (input)="checkNumerIsPositivgeneralInformationUserForm($event,'contactNo')">
                    <mat-error *ngIf="generalInformationUserForm.controls['contactNo'].hasError('required')">Mobile No.
                      is required</mat-error>
                    <mat-error *ngIf="generalInformationUserForm.controls['contactNo'].hasError('pattern')">Enter Valid Mobile No.
                      </mat-error>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Total Previous Experience Before Joining</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="totalExperience" 
                    (input)="checkNumerIsPositivgeneralInformationUserForm($event,'totalExperience')">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Emergency Contact Number</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="emergencyContactNo" 
                    (input)="checkNumerIsPositivgeneralInformationUserForm($event,'emergencyContactNo')">
                    <mat-error *ngIf="generalInformationUserForm.controls['emergencyContactNo'].hasError('pattern')">Enter
                      Valid Emergency Contact Number
                    </mat-error>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Blood Group</div>
                  <ng-select dropdownPosition="top" placeholder="Select Marital Status" formControlName="bloodGroup">
                    <ng-option value="A+">A+</ng-option>
                    <ng-option value="AB+">AB+</ng-option>
                    <ng-option value="O+">O+</ng-option>
                    <ng-option value="B-">B-</ng-option>
                    <ng-option value="AB-">AB-</ng-option>
                    <ng-option value="A-">A-</ng-option>
                    <ng-option value="B+">B+</ng-option>
                    <ng-option value="O-">O-</ng-option>
                    <ng-option value="A1+">A1+</ng-option>
                    <ng-option value="A1B+">A1B+</ng-option>
                    <ng-option value="A1-">A1-</ng-option>
                    <ng-option value="A2B+">A2B+</ng-option>
                    <ng-option value="A2-">A2-</ng-option>
                    <ng-option value="A1B-">A1B-</ng-option>
                    <ng-option value="A2+">A2+</ng-option>
                    <ng-option value="A2B-">A2B-</ng-option>
                  </ng-select>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Father's Name</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="fathersName">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Mother's Name</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="mothersName">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Spouse's Name</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="spouseName">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">No. of Children</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="noOfChildren" 
                    (input)="checkNumerIsPositivgeneralInformationUserForm($event,'noOfChildren')">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Is Relative Working?</div>
                  <ng-select dropdownPosition="top" [clearable]="false" placeholder="Select" formControlName="isRelativeWorking">
                    <ng-option [value]="true">Yes</ng-option>
                    <ng-option [value]="false">No</ng-option>
                  </ng-select>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10" 
                *ngIf="generalInformationUserForm.value.isRelativeWorking == true">
                  <div class="formLabelRegularfs14 mb-5">Name of Relative Working</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="workingRelativeName">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10"
                *ngIf="generalInformationUserForm.value.isRelativeWorking == true">
                  <div class="formLabelRegularfs14 mb-5">Relation of Relative Working</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="workingRelativeRelation">
                  </mat-form-field>
                </ion-col>
              </ion-row>
            </form>
          </div>
        </ion-accordion>
        <ion-accordion value="third" class="mb-10"
          [ngClass]="educationRelatedInformationUserForm.valid == false && addSubmitForm ? 'errorBorder':''">
          <ion-item slot="header">
            <label class="font_semibold fs-14 fs_12ForMobile">Education Related Information</label>
          </ion-item>
          <div class="p-10" slot="content">
            <form [formGroup]="educationRelatedInformationUserForm">
              <ion-row>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Highest Education Qualification</div>
                  <ng-select dropdownPosition="bottom" [addTag]="true" placeholder="Select Highest Education Qualification" formControlName="highestEducationQualification">
                    <ng-option [value]="item.id" *ngFor="let item of getListOfHighestQualificationOfComp">{{item.name}}</ng-option>
                  </ng-select>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Highest Education Institute</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="highestEducationInstitute">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Highest Education Year of Passing</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="highestEducationYearOfPassing"
                    (input)="checkNumerIsPositiveeducationRelatedInformationUserForm($event,'highestEducationYearOfPassing')">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Highest Education Marks/ %ge</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="highestEducationMarks">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">2nd Highest Education Qualification</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="highestEducationQualification2">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">2nd Highest Education Institute</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="highestEducationInstitute2">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">2nd Highest Education Year of Passing</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="highestEducationYearOfPassing2"
                    (input)="checkNumerIsPositiveeducationRelatedInformationUserForm($event,'highestEducationYearOfPassing2')">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">2nd Highest Education Marks/ %ge</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="highestEducationMarks2">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">3rd Highest Education Qualification</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="highestEducationQualification3">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">3rd Highest Education Institute</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="highestEducationInstitute3">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">3rd Highest Education Year of Passing</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="highestEducationYearOfPassing3"
                    (input)="checkNumerIsPositiveeducationRelatedInformationUserForm($event,'highestEducationYearOfPassing3')">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">3rd Highest Education Marks/ %ge</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="highestEducationMarks3">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Highest Professional Qualification</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="highestProfessionalQualification">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Highest Professional Institute</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="highestProfessionalInstitute">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Highest Professional Year of Passing</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="highestProfessionalYearOfPassing"
                    (input)="checkNumerIsPositiveeducationRelatedInformationUserForm($event,'highestProfessionalYearOfPassing')">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Highest Professional Marks/ %ge</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="highestProfessionalMarks">
                  </mat-form-field>
                </ion-col>
              </ion-row>
            </form>
          </div>
        </ion-accordion>
        <ion-accordion value="fourth" class="mb-10"
          [ngClass]="salaryRelatedInformationUserForm.valid == false && addSubmitForm ? 'errorBorder':''">
          <ion-item slot="header">
            <label class="font_semibold fs-14 fs_12ForMobile">Salary Related</label>
          </ion-item>
          <div class="p-10" slot="content">
            <form [formGroup]="salaryRelatedInformationUserForm">
              <ion-row>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Currency</div>
                  <ng-select dropdownPosition="bottom" [addTag]="true" placeholder="Select Currency" formControlName="currency">
                    <ng-option [value]="item.id" *ngFor="let item of getCurrencyList">{{item.name}}</ng-option>
                  </ng-select>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Salary Status<span class="red-cl">&nbsp;*</span></div>
                  <ng-select dropdownPosition="bottom" placeholder="Select Salary Status" formControlName="salaryStatus">
                    <ng-option value="Process">Process</ng-option>
                    <ng-option value="Hold">Hold</ng-option>
                    <ng-option value="FF">F&F</ng-option>
                  </ng-select>
                  <label class="fs-12 red-cl font_regular"
                  *ngIf="addSubmitForm && salaryRelatedInformationUserForm.controls['salaryStatus'].hasError('required')">Salary Status
                    is required</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Bank Name<span class="red-cl">&nbsp;*</span></div>
                  <ng-select [addTag]="true" placeholder="Select Bank Name" formControlName="bankName">
                    <ng-option [value]="item.id" *ngFor="let item of getBankNameList">{{item.name}}</ng-option>
                  </ng-select>
                  <label class="fs-12 red-cl font_regular"
                  *ngIf="addSubmitForm && salaryRelatedInformationUserForm.controls['bankName'].hasError('required')">Bank Name
                    is required</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Bank Branch Address<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="bankBranchAddress">
                    <mat-error *ngIf="salaryRelatedInformationUserForm.controls['bankBranchAddress'].hasError('required')">Bank Branch Address
                      is required</mat-error>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Bank Account No.<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="bankAccount" (blur)="checkAccountNo()"
                    (input)="checkNumerIsPositive($event,'bankAccount')">
                    <mat-error *ngIf="salaryRelatedInformationUserForm.controls['bankAccount'].hasError('required')">Bank Account No.
                      is required</mat-error>
                  </mat-form-field>
                  <label class="fs-12 red-cl font_regular" *ngIf="showErrorMsgOfExistAccountNo">Bank Account No. Already Exists</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">IFSC Code<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="ifscCode">
                    <mat-error *ngIf="salaryRelatedInformationUserForm.controls['ifscCode'].hasError('required')">IFSC Code
                      is required</mat-error>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Basic Salary PM<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number"
                     placeholder="Type number here" class="font_regular" formControlName="basicSalaryPm"
                     (input)="checkNumerIsPositive($event,'basicSalaryPm');caluclateGrossSalary();">
                    <mat-error *ngIf="salaryRelatedInformationUserForm.controls['basicSalaryPm'].hasError('required')">Basic Salary PM
                      is required</mat-error>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Dearness Allowance PM</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="daPm"
                     (input)="checkNumerIsPositive($event,'daPm');caluclateGrossSalary();">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">HRA PM</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="hraPm"
                     (input)="checkNumerIsPositive($event,'hraPm');caluclateGrossSalary();">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Other Allowance PM</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="otherAllowancePm"
                     (input)="checkNumerIsPositive($event,'otherAllowancePm');caluclateGrossSalary();">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">LTA PM</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="ltaPm"
                     (input)="checkNumerIsPositive($event,'ltaPm');caluclateGrossSalary();">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Medical Allowance PM</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="medicalAllowancePm"
                     (input)="checkNumerIsPositive($event,'medicalAllowancePm');caluclateGrossSalary();">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Washing Allowance PM</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="washingAllowancePm"
                     (input)="checkNumerIsPositive($event,'washingAllowancePm');caluclateGrossSalary();">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Special Allowance PM</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="specialAllowancePm"
                     (input)="checkNumerIsPositive($event,'specialAllowancePm');caluclateGrossSalary();">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Fuel/Petrol Allowance PM</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="fuelAllowancePm"
                     (input)="checkNumerIsPositive($event,'fuelAllowancePm');caluclateGrossSalary();">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Entertainment Allowance PM</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="entertainmentAllowancePm"
                     (input)="checkNumerIsPositive($event,'entertainmentAllowancePm');caluclateGrossSalary();">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Education Allowance PM</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="educationAllowancePm"
                     (input)="checkNumerIsPositive($event,'educationAllowancePm');caluclateGrossSalary();">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Books and Periodical Allowance PM</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="booksAllowancePm"
                     (input)="checkNumerIsPositive($event,'booksAllowancePm');caluclateGrossSalary();">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Statutory Bonus Allowance PM</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="statutoryBonusPm"
                     (input)="checkNumerIsPositive($event,'statutoryBonusPm');caluclateGrossSalary();">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Any Other Allowance PM</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="anyOtherAllowancePm"
                     (input)="checkNumerIsPositive($event,'anyOtherAllowancePm');caluclateGrossSalary();">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Gross Salary PM<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="grossSalaryPm"
                    (input)="checkNumerIsPositive($event,'grossSalaryPm')">
                    <mat-error *ngIf="salaryRelatedInformationUserForm.controls['grossSalaryPm'].hasError('required')">Gross Salary PM
                      is required</mat-error>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Employee PF PM</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="employeePfPm"
                    (input)="checkNumerIsPositive($event,'employeePfPm')">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Employer PF PM</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="employerPfPm"
                    (input)="checkNumerIsPositive($event,'employerPfPm')">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">PT PM</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="ptPm"
                    (input)="checkNumerIsPositive($event,'ptPm')">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">LWF PM</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="lwfPm"
                    (input)="checkNumerIsPositive($event,'lwfPm')">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">ESIC PM</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="esicPm"
                    (input)="checkNumerIsPositive($event,'esicPm')">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Any Other Retiral PM</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="otherRetiralPm"
                    (input)="checkNumerIsPositive($event,'otherRetiralPm')">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Total Retiral PM<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="totalRetiralPm"
                    (input)="checkNumerIsPositive($event,'totalRetiralPm')">
                    <mat-error *ngIf="salaryRelatedInformationUserForm.controls['totalRetiralPm'].hasError('required')">Total Retiral PM
                      is required</mat-error>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Fixed CTC Including Retirals PM<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="monthlyCTC"
                    (input)="checkNumerIsPositive($event,'monthlyCTC')">
                    <mat-error *ngIf="salaryRelatedInformationUserForm.controls['monthlyCTC'].hasError('required')">Fixed CTC Including Retirals PM
                      is required</mat-error>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Fixed CTC Including Retirals PA<span
                      class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="annualCTC"
                    (input)="checkNumerIsPositive($event,'annualCTC');caluclateAnnualTotalCTC()">
                    <mat-error *ngIf="salaryRelatedInformationUserForm.controls['annualCTC'].hasError('required')">Fixed CTC Including Retirals PA
                      is required</mat-error>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Process of Giving VP<span class="red-cl">&nbsp;*</span></div>
                  <ng-select dropdownPosition="top" placeholder="Select Salary Status" formControlName="processOfVp">
                    <ng-option value="Fixed VP">Fixed VP</ng-option>
                    <ng-option value="No VP">No VP</ng-option>
                    <ng-option value="%ge on CTC">%ge on CTC</ng-option>
                  </ng-select>
                  <label class="fs-12 red-cl font_regular"
                  *ngIf="addSubmitForm && salaryRelatedInformationUserForm.controls['processOfVp'].hasError('required')">Process of Giving VP
                    is required</label>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Annual Variable Pay Budget</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="annualVariablePayBudget"
                    (input)="checkNumerIsPositive($event,'annualVariablePayBudget');caluclateAnnualTotalCTC()">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Annual Total CTC (fixed CTC + annual variable pay
                    budget)<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Type number here" class="font_regular" formControlName="annualTotalCtc"
                    (input)="checkNumerIsPositive($event,'annualTotalCtc')">
                    <mat-error *ngIf="salaryRelatedInformationUserForm.controls['annualTotalCtc'].hasError('required')">Annual Total CTC (fixed CTC + annual variable pay
                      budget) is required</mat-error>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Increment on Fixed Annual CTC or Total Annual CTC<span
                      class="red-cl">&nbsp;*</span></div>
                  <ng-select dropdownPosition="top" placeholder="Select Salary Status" formControlName="incrementOn">
                    <ng-option value="Fixed Annual CTC">Fixed Annual CTC</ng-option>
                    <ng-option value="Total Annual CTC">Total Annual CTC</ng-option>
                  </ng-select>
                  <label class="fs-12 red-cl font_regular"
                  *ngIf="addSubmitForm && salaryRelatedInformationUserForm.controls['incrementOn'].hasError('required')">Increment on Fixed Annual CTC or Total Annual CTC
                    is required</label>
                </ion-col>
              </ion-row>
            </form>
          </div>
        </ion-accordion>
        <ion-accordion value="fifth" class="mb-10"
          [ngClass]="priorEmploymentRelatedInformationUserForm.valid == false && addSubmitForm ? 'errorBorder':''">
          <ion-item slot="header">
            <label class="font_semibold fs-14 fs_12ForMobile">Prior Employment Related</label>
          </ion-item>
          <div class="p-10" slot="content">
            <form [formGroup]="priorEmploymentRelatedInformationUserForm">
              <ion-row>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Last Organisation Before Joining</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="lastOrganisationName">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Last organisation Date Of Joining</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input readonly matInput [matDatepicker]="lastorgdateOfJoining" [max]="currentDate" formControlName="lastOrganisationDoj" placeholder="DD/MM/YYYY">
                    <mat-datepicker-toggle matIconSuffix [for]="lastorgdateOfJoining"></mat-datepicker-toggle>
                    <mat-datepicker #lastorgdateOfJoining></mat-datepicker>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Last organisation Last Working Of Date</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input readonly matInput [matDatepicker]="lastorglwd" [max]="currentDate" placeholder="DD/MM/YYYY" formControlName="lastOrganisationLwd">
                    <mat-datepicker-toggle matIconSuffix [for]="lastorglwd"></mat-datepicker-toggle>
                    <mat-datepicker #lastorglwd></mat-datepicker>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Last organisation Department</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="lastOrganisationDepartment">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Last organisation Designation</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="lastOrganisationDesignation">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Last to Last Organisation Before Joining</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="lastToLastOrganisationName">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Last to Last Organisation Date Of Joining</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input readonly matInput [matDatepicker]="lasttolastorgdateOfJoining" [max]="currentDate" placeholder="DD/MM/YYYY" formControlName="lastToLastOrganisationDoj">
                    <mat-datepicker-toggle matIconSuffix [for]="lasttolastorgdateOfJoining"></mat-datepicker-toggle>
                    <mat-datepicker #lasttolastorgdateOfJoining></mat-datepicker>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Last to Last Organisation Last Working Of Date</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input readonly matInput [matDatepicker]="lasttolastorglwd" [max]="currentDate" placeholder="DD/MM/YYYY" formControlName="lastToLastOrganisationLwd">
                    <mat-datepicker-toggle matIconSuffix [for]="lasttolastorglwd"></mat-datepicker-toggle>
                    <mat-datepicker #lasttolastorglwd></mat-datepicker>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Last to Last Organisation Department</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="lastToLastOrganisationDepartment">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Last to Last Organisation Designation</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="lastToLastOrganisationDesignation">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Any Other Organisation Joined Before</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="otherOrganisationName">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Any Other Organisation Date Of Joining</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input readonly matInput [matDatepicker]="anyOtherorgdateOfJoining" [max]="currentDate" placeholder="DD/MM/YYYY" formControlName="otherOrganisationDoj">
                    <mat-datepicker-toggle matIconSuffix [for]="anyOtherorgdateOfJoining"></mat-datepicker-toggle>
                    <mat-datepicker #anyOtherorgdateOfJoining></mat-datepicker>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Any Other Organisation Last Working Of Date</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input readonly matInput [matDatepicker]="anyOtherorglwd" [max]="currentDate" placeholder="DD/MM/YYYY" formControlName="otherOrganisationLwd">
                    <mat-datepicker-toggle matIconSuffix [for]="anyOtherorglwd"></mat-datepicker-toggle>
                    <mat-datepicker #anyOtherorglwd></mat-datepicker>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Any Other Organisation Department</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="otherOrganisationDepartment">
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                  <div class="formLabelRegularfs14 mb-5">Any Other Organisation Designation</div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput placeholder="Type text here" class="font_regular" formControlName="otherOrganisationDesignation">
                  </mat-form-field>
                </ion-col>
              </ion-row>
            </form>
          </div>
        </ion-accordion>
        <ion-accordion value="sixth" class="mb-10">
          <ion-item slot="header">
            <label class="font_semibold fs-14 fs_12ForMobile">Additional Field</label>
          </ion-item>
          <div class="p-10" slot="content">
            <ion-row>
              <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10" *ngFor="let item of customFieldObject">
                <div class="formLabelRegularfs14 mb-5">{{item.fieldName}}</div>
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <input matInput placeholder="Type text here" class="font_regular" [(ngModel)]="item.fieldValue">
                </mat-form-field>
              </ion-col>
            </ion-row>
          </div>
        </ion-accordion>
      </ion-accordion-group>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="mt-10">
      <button (click)="closeDialog()" class="back_btn fs-14 fs_12ForMobile">Cancel</button>
      <button (click)="replaceEmployee()"  type="button" class="add_btn fs-14 fs_12ForMobile ml-10" [style.background-color]="buttonColorName"
      >Add</button>
    </ion-col>
  </ion-row>
  <div class="clear20"></div>
</div>